import React, { forwardRef } from "react";

const textColors = {
  primary: "#2f4554",
  secondary: "#00b7c4"
};

const InfoCard = ({ style, className, ...props }) => (
  <div
    className={className} 
    style={{
      width: "fit-content",
      padding: "3.5px",
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "center",
      gap: "6px",
      ...style
    }}
    {...props}
  />
);

InfoCard.displayName = "InfoCard";

const InfoIcon = ({ style, className, src, ...props }) => (
  <img
    src={src}
    alt="icon"
    style={{
      maxWidth: "100%",
      height: "auto",
      objectFit: "contain",
      aspectRatio: "1/1",
      ...style
    }}
    className={className}
    {...props}
  />
);

InfoIcon.displayName = "InfoIcon";

const InfoHeader = forwardRef(({ style, className, ...props }, ref) => (
  <div
    ref={ref}
    className={className}
    style={{
      display: "flex",
      flexDirection: "column",
      gap: "3px",
      padding: "3.5px"
    }}
    {...props}
  />
));

InfoHeader.displayName = "InfoHeader";

const InfoContent = forwardRef(({ style, className, ...props }, ref) => (
  <section
    ref={ref}
    style={{
      display: "flex",
      flexDirection: "column",
      gap: "3px",
      flexWrap: "nowrap",
      textWrap: "nowrap",
      whiteSpace: "nowrap",
      ...style
    }}
    className={className}
    {...props}
  />
));

InfoContent.displayName = "InfoContent";

const InfoTitle = ({ style, className, color, children, ...props }) => {
  return (
    <h4
      style={{
        margin: 0,
        fontSize: "1.025rem",
        fontFamily: "Roboto, Arial, sans-serif",
        fontWeight: "bold",
        whiteSpace: "nowrap !important",
        textWrap: "nowrap !imporant",
        color: textColors[color] || textColors.primary,
        ...style
      }}
      className={className}
      {...props}>
      {children}
    </h4>
  );
};

InfoTitle.displayName = "InfoTitle";

const InfoText = ({ style, className, color, children, ...props }) => (
  <p
    style={{
      margin: 0,
      fontFamily: "Roboto, Arial, sans-serif",
      fontSize: "0.925rem",
      fontWeight: "600",
      whiteSpace: "nowrap !important",
      textWrap: "nowrap !imporant",
      color: textColors[color] || textColors.secondary,
      ...style
    }}
    className={className}
    {...props}>
    {children}
  </p>
);

InfoText.displayName = "InfoText";

export { InfoCard, InfoHeader, InfoIcon, InfoContent, InfoTitle, InfoText };
